import React from "react";
import { Section, SerifH, Eyebrow, PrimaryButton } from "../components/ui-kit/Primitives";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "../components/ui/accordion";

const faqs = [
  {
    q: "Do you help people start peer support agencies?",
    a: "Yes. KBX Pathways To Wellness provides consulting support for individuals and organizations looking to start or structure a peer support agency.",
  },
  {
    q: "Do you provide NCTracks support?",
    a: "We provide guidance and preparation support related to NCTracks readiness, documentation, business structure, and provider setup. We do not guarantee approval, but we help agencies become more organized and prepared.",
  },
  {
    q: "Do you help with insurance and W-9 information?",
    a: "Yes. We help agencies understand what documents and insurance information may be needed for professional setup, credentialing readiness, and partnerships.",
  },
  {
    q: "Do you provide direct peer support services?",
    a: "KBX Pathways To Wellness is preparing to offer peer support services. This is an upcoming service area — please reach out to learn how we can support you when services become available.",
  },
  {
    q: "Who do you work with?",
    a: "We work with peer support agencies, Certified Peer Support Specialists, behavioral health entrepreneurs, community-based organizations, and individuals seeking wellness support.",
  },
  {
    q: "Do you guarantee funding, credentialing, or Medicaid approval?",
    a: "No. KBX provides consulting, preparation, structure, and strategy. We do not guarantee approvals, funding outcomes, credentialing decisions, or payer enrollment results.",
  },
];

const FAQ = () => (
  <div data-testid="faq-page">
    <Section className="pt-16">
      <div className="max-w-3xl">
        <Eyebrow>Frequently Asked</Eyebrow>
        <SerifH as="h1" className="text-5xl sm:text-6xl">
          Questions worth answering — clearly.
        </SerifH>
        <p className="mt-6 text-lg text-slate-600 font-light leading-relaxed">
          A few of the questions we hear most from peer support agencies, founders, and the
          communities we serve.&nbsp;
        </p>
      </div>
    </Section>

    <Section className="pt-0">
      <div className="max-w-3xl">
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-brand-green/15">
              <AccordionTrigger
                data-testid={`faq-question-${i}`}
                className="text-left font-serif text-xl text-brand-green hover:no-underline py-6"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-700 text-[15px] leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </Section>

    <Section className="bg-brand-mist/60">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-8">
          <SerifH className="text-4xl sm:text-5xl">Have a question we did not cover?</SerifH>
        </div>
        <div className="lg:col-span-4 lg:text-right">
          <PrimaryButton to="/contact" testid="faq-cta">Reach out</PrimaryButton>
        </div>
      </div>
    </Section>
  </div>
);

export default FAQ;
